module.exports = __webpack_public_path__ + "img/btn-new-banner-r.b30811f9.svg";